import { useEffect } from "react";
import { initializeOpenPanel } from "../lib/openpanel";
import AppProviders from "./AppProviders";
import { AppRouter } from "./Router";

export function App() {
  useEffect(() => {
    initializeOpenPanel();
  }, []);

  return (
    <AppProviders>
      <AppRouter />
    </AppProviders>
  );
}
